import { useRecoilValue } from 'recoil';
import { OverlayState } from '../../recoil/overlay/overlay.state';
import { events } from '../../test.data';
import OverlayOptionButton from '../button/v2/overlay-option.button';
import { getEventsDropdownOptions } from '../dropdown/utils/getOptions';
import { VStack } from '../layouts/stack.layout';

export default function EventOverlay() {
  const { id } = useRecoilValue(OverlayState);

  const data = events.find((item) => item.id === id);

  const options = getEventsDropdownOptions();

  return (
    <VStack extensions="w-full" gap="sm">
      {options.map(({ icon, text, action }) => (
        <OverlayOptionButton icon={icon} text={text} action={action} />
      ))}
    </VStack>
  );
}
